import { Col, Row } from "v2/components/base/Flex/ui";

const AppSideBarWrapper = ({
  children,
  ...props
}: {
  children: React.ReactNode;
  [key: string]: any;
}) => {
  return (
    <Row fullHeight>
      <Col type="bc" fullHeight {...props}>
        {children}
      </Col>
    </Row>
  );
};

export default AppSideBarWrapper;
